import { getDiscountType } from 'chemistry'
import { BONUS_BUYS_BANNER_TYPE } from '../constants'
import {
  getEqualBannerTitleDescription,
  getPricePromotionTitleDescription,
  getQualifiedBannerTitle,
  getTargetBannerTitle
} from './getBannerTitleDescription'

export const getBonusBuysBannerTitleAndDescription = ({
  bannerType,
  promotion,
  promotionWithLoyalty,
  targetName,
  productDetails,
  amount,
  isMultiTarget,
  t
}) => {
  const discountType = getDiscountType(promotion)
  const loyalty = promotionWithLoyalty ? ` ${t('met_praxis_plus')}` : ' '

  if (bannerType === BONUS_BUYS_BANNER_TYPE.PRICE) {
    return getPricePromotionTitleDescription(promotion, t)
  }
  if (bannerType === BONUS_BUYS_BANNER_TYPE.EQUAL) {
    return getEqualBannerTitleDescription(promotion, t)
  }

  const description = t('unequal_pdp_discount_description')
  if (bannerType === BONUS_BUYS_BANNER_TYPE.QUALIFIED) {
    return {
      title: getQualifiedBannerTitle({
        discountType,
        amount,
        loyalty,
        targetName,
        isMultiTarget,
        productName: productDetails.name,
        t
      }),
      description
    }
  }
  if (bannerType === BONUS_BUYS_BANNER_TYPE.TARGET) {
    return {
      title: getTargetBannerTitle({
        discountType,
        amount,
        loyalty,
        productName: productDetails.name,
        t
      }),
      description
    }
  }
}
